const getProducts = (action) => action.entities.products;

export default function productsReducer(state = {}, action) {
  switch (action.type) {
    case "PRODUCT_FETCHED":
    case "PRODUCTS_FETCHED":
      return { ...state, ...getProducts(action) };
    default:
      return state;
  }
}
